module.exports = __webpack_public_path__ + "img/inventory.c4689877.svg";